<p class="rs-p-wp-fix"></p>
<rs-module-wrap id="rev_slider_9_1_wrapper" data-alias="slider-1" data-source="gallery" style="background:transparent;padding:0;margin:0px auto;margin-top:0;margin-bottom:0;">
    <rs-module id="rev_slider_9_1" style="display:none;" data-version="6.1.8">
    <rs-slides>
        <rs-slide data-key="rs-12" data-title="Slide" data-anim="ei:d;eo:d;s:1000;r:0;t:fade;sl:0;">
        <img src="./assets/revslider/assets/bg-sdd.jpg" alt="img" title="bg-sdd" width="1600" height="892" class="rev-slidebg"
            data-no-retina>
        <!--
    -->
        <rs-group id="slider-9-slide-12-layer-19" data-type="group" data-rsp_ch="on"
            data-xy="x:l,l,c,c;xo:5px,5px,0,0;y:t,t,m,m;yo:641px,641px,-12px,60px;"
            data-text="w:normal;s:20,20,9,5;l:0,0,12,7;" data-dim="w:456px,456px,376px,355px;h:180px,180px,128px,124px;"
            data-frame_0="x:0,0,0px,0px;y:0,0,0px,0px;o:1;" data-frame_1="x:0,0,0px,0px;y:0,0,0px,0px;"
            data-frame_999="o:0;st:w;sA:9000;" style="z-index:19;">
            <!--
    -->
            <rs-layer id="slider-9-slide-12-layer-4" data-type="image" data-rsp_ch="on"
            data-xy="x:l,l,c,c;xo:-74px,-74px,4px,2px;y:b;yo:-53px,-53px,-26px,-17px;"
            data-text="w:normal;s:20,20,9,5;l:0,0,12,7;" data-dim="w:565px,565px,356px,351px;h:255px,255px,161px,158px;"
            data-frame_0="x:left;y:0,0,0,0px;" data-frame_1="x:0,0,0,0px;y:0,0,0,0px;st:3840;sp:1000;sR:3840;"
            data-frame_999="o:0;st:w;sR:4160;" style="z-index:16;"><img src="./assets/revslider/assets/slider-064png.png"
                alt="img" width="565" height="255" data-no-retina>
            </rs-layer>
            <!--
    --><a id="slider-9-slide-12-layer-5" class="rs-layer popup-youtube" href="#" target="_self" rel="nofollow"
            data-type="button" data-rsp_ch="on"
            data-xy="x:l,l,c,c;xo:293px,293px,77px,70px;y:b,b,m,m;yo:48px,48px,8px,-1px;"
            data-text="w:normal;s:20,20,12,11;l:60,60,36,38;a:center;"
            data-dim="w:60px,60px,36px,38px;h:60px,60px,36px,38px;minw:60px,60px,none,none;minh:60px,60px,none,none;"
            data-border="bos:solid;boc:#ffffff;bow:1px,1px,1px,1px;bor:50%,50%,50%,50%;"
            data-frame_0="x:0,0,0px,0px;y:0,0,0px,0px;sX:0.9;sY:0.9;"
            data-frame_1="x:0,0,0px,0px;y:0,0,0px,0px;st:4160;sp:1000;sR:4160;" data-frame_999="o:0;st:w;sR:3840;"
            style="z-index:17;background-color:rgba(0,0,0,0);text-transform:uppercase;"><i
                class="fa-play"></i>
            </a>
            <!--
    -->
            <rs-layer id="slider-9-slide-12-layer-6" data-type="text" data-color="#5e7290" data-rsp_ch="on"
            data-xy="x:l,l,c,c;xo:9px,9px,-61px,-68px;y:b,b,b,m;yo:47px,47px,37px,0;"
            data-text="w:normal;s:18,18,14,14;l:25,25,24,24;" data-frame_0="x:0,0,0,0px;y:100%;"
            data-frame_0_mask="u:t;x:0,0,0,0px;y:0,0,0,0px;"
            data-frame_1="x:0,0,0,0px;y:0,0,0,0px;st:3340;sp:1200;sR:3340;"
            data-frame_1_mask="u:t;x:0,0,0,0px;y:0,0,0,0px;" data-frame_999="o:0;st:w;sR:4460;"
            style="z-index:18;">Watch our videos<br />
            for cloud computing
            </rs-layer>
            <!--
    -->
            <rs-layer id="slider-9-slide-12-layer-7" data-type="image" data-rsp_ch="on"
            data-xy="x:l,l,l,c;xo:379px,379px,306px,0;y:b,b,b,m;yo:36px,36px,33px,0;"
            data-text="w:normal;s:20,20,9,5;l:0,0,12,7;" data-dim="w:87px,87px,41px,39px;h:101px,101px,48px,44px;"
            data-frame_0="x:-100%;y:0,0,0,0px;" data-frame_0_mask="u:t;x:0,0,0,0px;y:0,0,0,0px;"
            data-frame_1="x:0,0,0,0px;y:0,0,0,0px;st:3770;sp:1000;sR:3770;"
            data-frame_1_mask="u:t;x:0,0,0,0px;y:0,0,0,0px;" data-frame_999="o:0;st:w;sR:4230;" data-loop_0="y:5px;"
            data-loop_999="y:-5px;sp:3000;e:Sine.easeInOut;yym:t;" style="z-index:15;"><img
                src="./assets/revslider/assets/boy.png" alt="img" width="87" height="101" data-no-retina>
            </rs-layer>
            <!--
    -->
        </rs-group>
        <!--
    -->
        <rs-layer id="slider-9-slide-12-layer-0" class="textgyreadventor" data-type="text" data-color="#007bfc"
            data-rsp_ch="on" data-xy="x:l,l,c,c;xo:210px,210px,0,0;yo:200px,200px,146px,113px;"
            data-text="w:normal;s:72,72,45,40;l:100,100,60,50;a:left,left,center,center;" data-frame_0="y:100%;"
            data-frame_0_mask="u:t;" data-frame_1="st:320;sp:1200;sR:320;" data-frame_1_mask="u:t;"
            data-frame_999="o:0;st:w;sR:7480;" style="z-index:8;">Qloud Computing <br />

        </rs-layer>
        <!--
    -->
        <rs-layer id="slider-9-slide-12-layer-1" class="textgyreadventor" data-type="text" data-color="#0d1e67"
            data-rsp_ch="on" data-xy="x:l,l,c,c;xo:210px,210px,0,0;yo:290px,290px,200px,162px;"
            data-text="w:normal;s:72,72,45,40;l:90,90,60,50;a:left,left,center,center;" data-frame_0="y:100%;"
            data-frame_0_mask="u:t;" data-frame_1="st:540;sp:1200;sR:540;" data-frame_1_mask="u:t;"
            data-frame_999="o:0;st:w;sR:7260;" style="z-index:10;">Service
        </rs-layer>
        <!--
    -->
        <rs-layer id="slider-9-slide-12-layer-2" data-type="text" data-color="#5e7290" data-rsp_ch="on"
            data-xy="x:l,l,c,c;xo:216px,216px,0,0;yo:394px,394px,271px,227px;"
            data-text="w:normal;s:18,18,14,16;l:28,28,24,26;a:left,left,center,center;" data-frame_0="y:100%;"
            data-frame_0_mask="u:t;" data-frame_1="st:860;sp:1200;sR:860;" data-frame_1_mask="u:t;"
            data-frame_999="o:0;st:w;sR:6940;" style="z-index:11;">Lorem ipsum dolor sit amet,
            consectetur adipiscing<br> elit, sed do eiusmod facilisis.
        </rs-layer>
        <!--
    -->
        <rs-layer id="slider-9-slide-12-layer-3" class="rev-btn" data-type="button" data-rsp_ch="on"
            data-xy="x:l,l,c,c;xo:210px,210px,0,0;y:m;yo:70px,70px,-120px,-30px;"
            data-text="w:normal;s:18,18,14,14;l:50,50,14,14;" data-dim="minh:0px,0px,none,none;"
            data-padding="t:0,0,12,12;r:40,40,30,30;b:0,0,12,12;l:40,40,30,30;" data-border="bor:3px,3px,3px,3px;"
            data-frame_0="y:100%;" data-frame_0_mask="u:t;" data-frame_1="st:1060;sp:1200;sR:1060;"
            data-frame_1_mask="u:t;" data-frame_999="o:0;st:w;sR:6740;"
            data-frame_hover="bgc:#142149;bor:3px,3px,3px,3px;sp:500ms;e:Power1.easeInOut;bri:120%;"
            style="z-index:12;background-color:#007aff;">Join Now
        </rs-layer>
        <!--
    -->
        <rs-layer id="slider-9-slide-12-layer-8" data-type="image" data-rsp_ch="on"
            data-xy="x:r;xo:290px,290px,350px,206px;y:m;yo:0,0,230px,210px;" data-text="w:normal;s:20,20,9,5;l:0,0,12,7;"
            data-dim="w:198px,198px,95px,58px;h:384px,384px,186px,114px;" data-frame_0="y:100%;" data-frame_0_mask="u:t;"
            data-frame_1="st:1880;sp:1200;sR:1880;" data-frame_1_mask="u:t;" data-frame_999="o:0;st:w;sR:5920;"
            style="z-index:22;"><img src="./assets/revslider/assets/slider-060.png" alt="img" width="198" height="384"
            data-no-retina>
        </rs-layer>
        <!--
    -->
        <rs-layer id="slider-9-slide-12-layer-9" data-type="image" data-rsp_ch="on"
            data-xy="x:r;xo:282px,282px,345px,201px;yo:129px,129px,556px,472px;"
            data-text="w:normal;s:20,20,9,5;l:0,0,12,7;" data-dim="w:185px,185px,89px,56px;h:205px,205px,99px,62px;"
            data-frame_0="y:-100%;" data-frame_0_mask="u:t;" data-frame_1="st:2490;sp:1200;sR:2490;"
            data-frame_1_mask="u:t;" data-frame_999="o:0;st:w;sR:5310;" data-loop_0="y:10px;"
            data-loop_999="sp:3000;e:Sine.easeInOut;yym:t;" style="z-index:23;"><img src="./assets/revslider/assets/cloud.png"
            alt="img" width="185" height="205" data-no-retina>
        </rs-layer>
        <!--
    -->
        <rs-layer id="slider-9-slide-12-layer-10" data-type="image" data-rsp_ch="on"
            data-xy="x:r;xo:534px,534px,469px,279px;y:m;yo:84px,84px,270px,234px;"
            data-text="w:normal;s:20,20,9,5;l:0,0,12,7;" data-dim="w:126px,126px,60px,43px;h:170px,170px,82px,58px;"
            data-frame_0="y:100%;" data-frame_0_mask="u:t;" data-frame_1="st:3670;sp:1200;sR:3670;"
            data-frame_1_mask="u:t;" data-frame_999="o:0;st:w;sR:4130;" style="z-index:24;"><img
            src="./assets/revslider/assets/b1.png" alt="img" width="126" height="170" data-no-retina>
        </rs-layer>
        <!--
    -->
        <rs-layer id="slider-9-slide-12-layer-11" data-type="image" data-rsp_ch="on"
            data-xy="x:r;xo:260px,260px,336px,197px;y:m;yo:203px,203px,328px,270px;"
            data-text="w:normal;s:20,20,9,5;l:0,0,12,7;" data-dim="w:126px,126px,60px,42px;h:170px,170px,82px,57px;"
            data-frame_0="y:100%;" data-frame_0_mask="u:t;" data-frame_1="st:3670;sp:1200;sR:3670;"
            data-frame_1_mask="u:t;" data-frame_999="o:0;st:w;sR:4130;" style="z-index:25;"><img
            src="./assets/revslider/assets/b2.png" alt="img" width="126" height="170" data-no-retina>
        </rs-layer>
        <!--
    -->
        <rs-layer id="slider-9-slide-12-layer-12" data-type="image" data-rsp_ch="on"
            data-xy="x:r;xo:200px,200px,307px,179px;y:m;yo:-38px,-38px,212px,199px;"
            data-text="w:normal;s:20,20,9,5;l:0,0,12,7;" data-dim="w:126px,126px,60px,40px;h:170px,170px,82px,54px;"
            data-frame_0="y:100%;" data-frame_0_mask="u:t;" data-frame_1="st:3210;sp:1200;sR:3210;"
            data-frame_1_mask="u:t;" data-frame_999="o:0;st:w;sR:4590;" style="z-index:21;"><img
            src="./assets/revslider/assets/b2.png" alt="img" width="126" height="170" data-no-retina>
        </rs-layer>
        <!--
    -->
        <rs-layer id="slider-9-slide-12-layer-13" data-type="image" data-rsp_ch="on"
            data-xy="xo:913px,913px,238px,159px;yo:259px,259px,618px,507px;" data-text="w:normal;s:20,20,9,5;l:0,0,12,7;"
            data-dim="w:464px,464px,224px,144px;h:506px,506px,245px,157px;" data-frame_0="sX:0.9;sY:0.9;"
            data-frame_1="st:2920;sp:1000;sR:2920;" data-frame_999="o:0;st:w;sR:5080;" style="z-index:20;"><img
            src="./assets/revslider/assets/line.png" alt="img" width="464" height="506" data-no-retina>
        </rs-layer>
        <!--
    -->
        <rs-layer id="slider-9-slide-12-layer-14" data-type="image" data-rsp_ch="on"
            data-xy="x:r;xo:-7px,-7px,207px,119px;y:m;yo:23px,23px,240px,216px;"
            data-text="w:normal;s:20,20,9,5;l:0,0,12,7;" data-dim="w:758px,758px,368px,241px;h:758px,758px,368px,241px;"
            data-frame_0="sX:0.9;sY:0.9;" data-frame_1="st:5580;sp:1000;sR:5580;" data-frame_999="o:0;st:w;sR:2420;"
            data-loop_999="rZ:360;sp:80000;" style="z-index:14;"><img src="./assets/revslider/assets/slider-058.png" alt="img"
            width="902" height="902" data-no-retina>
        </rs-layer>
        <!--
    -->
        <rs-layer id="slider-9-slide-12-layer-15" data-type="image" data-rsp_ch="on"
            data-xy="x:r;xo:174px,174px,294px,171px;y:m;yo:7px,7px,233px,211px;"
            data-text="w:normal;s:20,20,9,5;l:0,0,12,7;" data-dim="w:444px,444px,215px,132px;h:444px,444px,215px,132px;"
            data-frame_0="sX:0.9;sY:0.9;" data-frame_1="st:4220;sp:1000;sR:4220;" data-frame_999="o:0;st:w;sR:3780;"
            data-loop_999="rZ:-360deg;sp:80000;" style="z-index:13;"><img src="./assets/revslider/assets/slider-059.png" alt="img"
            width="444" height="444" data-no-retina>
        </rs-layer>
        <!--
    -->
        <rs-layer id="slider-9-slide-12-layer-16" data-type="image" data-rsp_ch="on"
            data-xy="xo:382px,382px,369px,209px;yo:89px,89px,89px,77px;" data-text="w:normal;s:20,20,9,5;l:0,0,12,7;"
            data-dim="w:127px,127px,74px,57px;h:50px,50px,29px,22px;" data-frame_0="sX:0.9;sY:0.9;"
            data-frame_1="st:2110;sp:1000;sR:2110;" data-frame_999="o:0;st:w;sR:5890;" data-loop_0="x:-100;"
            data-loop_999="x:100;sp:30000;e:Sine.easeInOut;yym:t;" style="z-index:9;"><img src="./assets/revslider/assets/sky.png"
            alt="img" width="127" height="50" data-no-retina>
        </rs-layer>
        <!--
    -->
        <rs-layer id="slider-9-slide-12-layer-17" data-type="shape" data-rsp_ch="on"
            data-xy="xo:651px,651px,63px,38px;yo:468px,468px,563px,347px;" data-text="w:normal;s:20,20,9,5;l:0,0,12,7;"
            data-dim="w:16px,16px,15px,9px;h:16px,16px,15px,9px;" data-border="bor:90%,90%,90%,90%;"
            data-frame_0="x:0,0,0px,0px;y:0,0,0px,0px;sX:0.9;sY:0.9;"
            data-frame_1="x:0,0,0px,0px;y:0,0,0px,0px;st:1280;sp:1000;" data-frame_999="o:0;st:w;sR:7420;"
            data-loop_0="xR:5px;yR:5px;" data-loop_999="xR:5px;yR:5px;crd:t;sp:3000;"
            style="z-index:27;background-color:rgba(20,33,73,0.1);">
        </rs-layer>
        <!--
    -->
        <rs-layer id="slider-9-slide-12-layer-18" data-type="shape" data-rsp_ch="on"
            data-xy="xo:541px,541px,685px,48px;yo:148px,148px,103px,93px;" data-text="w:normal;s:20,20,9,5;l:0,0,12,7;"
            data-dim="w:16px,16px,14px,10px;h:16px,16px,14px,10px;" data-border="bor:90%,90%,90%,90%;"
            data-frame_0="x:0,0,0px,0px;y:0,0,0px,0px;sX:0.9;sY:0.9;"
            data-frame_1="x:0,0,0px,0px;y:0,0,0px,0px;st:1280;sp:1000;" data-frame_999="o:0;st:w;sR:7420;"
            data-loop_0="xR:2px;yR:2px;" data-loop_999="xR:2px;yR:2px;crd:t;sp:3000;"
            style="z-index:26;background-color:rgba(0,123,252,0.1);">
        </rs-layer>
        <!--
    -->
        </rs-slide>
    </rs-slides>
    <rs-progress class="rs-bottom" style="visibility: hidden !important;"></rs-progress>
    </rs-module>
    <script>
    if (typeof revslider_showDoubleJqueryError === "undefined") {
        function revslider_showDoubleJqueryError(sliderID) {
        var err = "<div class='rs_error_message_box'>";
        err += "<div class='rs_error_message_oops'>Oops...</div>";
        err += "<div class='rs_error_message_content'>";
        err += "You have some jquery.js library include that comes after the Slider Revolution files js inclusion.<br>";
        err +=
            "To fix this, you can:<br>&nbsp;&nbsp;&nbsp; 1. Set 'Module General Options' -> 'Advanced' -> 'jQuery & OutPut Filters' -> 'Put JS to Body' to on";
        err += "<br>&nbsp;&nbsp;&nbsp; 2. Find the double jQuery.js inclusion and remove it";
        err += "</div>";
        err += "</div>";
        jQuery(sliderID).show().html(err);
        }
    }
    </script>
    </rs-module-wrap>
